import React, { useEffect, useRef, useState } from "react";
import "./Help_Support.css";
import { FiPhoneCall } from "react-icons/fi";
import { FaRegEnvelope } from "react-icons/fa";
import { Link } from "react-router-dom";
import { TextArea } from "../../../../components/header/form";
import { GiHamburgerMenu } from "react-icons/gi";
import { useSelector } from "react-redux";
import { toastMessage } from "../../../../utils/toastMessage";
import { supportIcon } from "../../../../assets";
import moment from "moment";
import { BsFillSendFill } from "react-icons/bs";
import { socket } from "../../../../utils/socket";
import InfiniteScroll from "react-infinite-scroll-component";
import FlatList from "components/FlatList";
import HelpMessageLoading from "./HelpMessageLoading";
import { groupBy } from "utils/commonHelper";

const Help_Support = () => {
  const [inputData, setInputData] = useState({ message: "", type: "" });
  const chatEndRef = useRef(null);
  const chatContainerRef = useRef(null);
  const { showAuth } = useSelector((state) => state?.showAuth);
  let [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [currentMessage, setCurrentMessage] = useState([]);
  const [messageList, setMessageList] = useState([]);

  const inputRef = useRef();

  // auto height of input based on content
  const inputKeyUpHandler = () => {
    if (inputRef.current) {
      inputRef.current.style.height =
        inputRef?.current?.scrollHeight > inputRef?.current?.clientHeight
          ? inputRef?.current?.scrollHeight + "px"
          : "50px";
    }
  };

  //-----------all-listener--------------------
  useEffect(() => {
    socket.on("RECEIVE_COMPLAINT_MESSAGE_LIST", (data) => {
      setTotalPages(data?.meta?.totalPages);
      if (data?.meta?.page === 1) setMessageList(data?.data);
      else setMessageList((it) => [...it, ...data?.data]);
    });

    socket.on("COMPLAINT_RECEIVE_MESSAGE", (data) => {
      setCurrentMessage("");
      setMessageList((it) => [data?.data, ...it]);
    });

    return () => {
      socket.off("RECEIVE_COMPLAINT_MESSAGE_LIST");
      socket.off("COMPLAINT_RECEIVE_MESSAGE");
      socket.emit("REQUEST_LEAVE_COMPLAINT_ROOM");
    };
  }, []);

  const handleEmitMessageList = () => {
    const _payload = {
      page: page,
      limit: 10,
    };
    socket.emit("REQUEST_COMPLAINT_MESSAGE_LIST", _payload);
  };

  const handleLoadMore = () => {
    if (page <= totalPages) {
      page = page + 1;
      setPage(page);
      handleEmitMessageList();
    }
  };
  useEffect(() => {
    page = 1;
    setPage(page);
    handleEmitMessageList();
  }, []);

  //---------send-message---------------
  const sendDataHandler = () => {
    if (inputData?.message?.trim().length === 0) {
      toastMessage("Message should not be empty", "error", "id123");
      return;
    }
    const _payload = {
      message: inputData?.message,
      type: "TEXT",
    };
    socket.emit("COMPLAINT_SENT_MESSAGE", _payload);
  };

  //----------enter-press--send-message--------------
  const onEnterPress = (event) => {
    if (event.key === "Enter" && !event.shiftKey) {
      event.preventDefault();
      if (inputData?.message.trim()) {
        sendDataHandler(inputData.message);
        setInputData({ ...inputData, message: "" });
      }
    } else if (event.key === "Enter" && event.shiftKey) {
      event.preventDefault();
      setInputData({
        ...inputData,
        message: inputData?.message + "\n",
      });
    }
  };

  // Auto-scroll new
  const scrollBottom = () => {
    if (chatEndRef.current && page === 1) {
      chatEndRef.current.scrollIntoView({ behavior: "instant" });
    }
  };

  //   Load More older message
  // const loadMoreMessages = () => {
  //   const chatContainer = chatContainerRef.current;
  //   if (chatContainer.scrollTop === 0 && totalPages > currentPage) {
  //     // fetchMessages(currentPage + 1);
  //     setCurrentPage((prev) => prev + 1);
  //   }
  // };

  return (
    <>
      <div className="help_support">
        <div className="container_help_sprt">
          <div className="hlp_sprt_tittle">
            <h2>Help & Support</h2>

            <div className="help-time">
              <p>
                We are happy to hear from you. we are available from 9 AM to 7
                PM on Monday to Friday.
              </p>
            </div>
          </div>

          <ul className="phn_id_content">
            <li>
              <Link to="tel:9990256258">
                <FiPhoneCall />
                &nbsp; 9990 256 258
              </Link>
            </li>
            <li className="">
              <Link to="mailto:asdasd@gmail.com">
                <FaRegEnvelope />
                &nbsp; tim.jennings@example.com
              </Link>
            </li>
          </ul>
        </div>

        <div className="help_support_chatbox">
          <div className="chatting ">
            {/* -------chatMessage.length > 0 ?---this condition-work-if-chatMessage-empty-then-show-no-data-found------ */}
            {/* {chatMessage && chatMessage.length > 0 ? ( */}
            <>
              <div className="chat_wrapper">
                <div className="chat-header">
                  <div
                    className="responsive_menubar"
                    // onClick={showChatUsers}
                  >
                    <button>
                      <GiHamburgerMenu />
                    </button>
                  </div>
                  <div className="avatar">
                    <img src={supportIcon} alt="" />
                  </div>
                  <div className="text-content">
                    <div className="title">Support Chat</div>
                  </div>
                </div>

                <div
                  id="group_chat_div"
                  className="chat-messages"
                  ref={chatContainerRef}
                  style={{
                    // height: 200,
                    overflow: "auto",
                    display: "flex",
                    flexDirection: "column-reverse",
                  }}
                >
                  <InfiniteScroll
                    dataLength={messageList.length}
                    next={handleLoadMore}
                    hasMore={page < totalPages}
                    loader={<HelpMessageLoading />}
                    inverse
                    scrollableTarget="group_chat_div"
                    style={{ display: "flex", flexDirection: "column-reverse" }}
                    scrollThreshold={0.8}
                  >
                    <div ref={chatEndRef} />

                    <FlatList
                      data={groupBy(messageList, "createdAt")}
                      waitForRender
                      loadingItem={(it) => <HelpMessageLoading key={it} />}
                      renderItem={({ date, data: messages }) => {
                        return (
                          <React.Fragment key={date}>
                            <FlatList
                              data={messages}
                              renderItem={(data) => {
                                if (data?._sender?._id === showAuth?._id) {
                                  return (
                                    <div
                                      className="unique_message_box"
                                      key={data._id}
                                    >
                                      <div className="message-sender">
                                        <pre className="msg-text">
                                          {data?.message || ""}
                                        </pre>
                                      </div>
                                    </div>
                                  );
                                } else {
                                  return (
                                    <div className="msg-item" key={data._id}>
                                      <div className="msg-avatar">
                                        <img
                                          className=""
                                          src={
                                            data?._sender?.profilePicture ||
                                            supportIcon
                                          }
                                          alt="Avatar"
                                        />
                                      </div>
                                      <div className="msg-content">
                                        <div className="msg-header">
                                          <span className="msg-name">
                                            {data?._sender?.fullName}
                                          </span>
                                          <span className="msg-time">
                                            {moment(data?.createdAt).fromNow()}
                                          </span>
                                        </div>
                                        <div className="msg-text_wrap">
                                          <div className="msg-text">
                                            <pre>{data?.message || ""}</pre>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  );
                                }
                              }}
                            />
                            <div className="date_wrap">
                              <p className="date">{date}</p>
                            </div>
                          </React.Fragment>
                        );
                      }}
                      onRenderComplete={scrollBottom}
                    />
                  </InfiniteScroll>
                </div>

                {/* <div
                  className="chat-messages"
                  ref={chatContainerRef}
                  onScroll={handleLoadMore}
                >
                  {messageList &&
                    messageList
                      .sort(
                        (a, b) => new Date(a.createdAt) - new Date(b.createdAt)
                      ) // Sort the messages by date
                      .map((data, ind) => {
                        // Check if the message is from the authenticated user
                        if (data?._sender?._id === showAuth?._id) {
                          return (
                            <div className="unique_message_box" key={ind}>
                              <div className="message-sender">
                                <pre className="msg-text">
                                  {data?.message || ""}
                                </pre>
                              </div>
                            </div>
                          );
                        } else {
                          return (
                            <div className="msg-item" key={data._id}>
                              <div className="msg-avatar">
                                <img
                                  className=""
                                  src={
                                    data?._sender?.profilePicture || supportIcon
                                  }
                                  alt="Avatar"
                                />
                              </div>
                              <div className="msg-content">
                                <div className="msg-header">
                                  <span className="msg-name">
                                    {data?._sender?.fullName}
                                  </span>
                                  <span className="msg-time">
                                    {moment(data?.createdAt).fromNow()}
                                  </span>
                                </div>
                                <div className="msg-text_wrap">
                                  <div className="msg-text">
                                    <pre>{data?.message || ""}</pre>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        }
                      })}
                  <div ref={chatEndRef} />
                </div> */}
              </div>
              {/* --------send-message--input--------------- */}
              <div className="chat-input">
                <TextArea
                  type="text"
                  ref={inputRef}
                  // disabled={attachment?.attachment}
                  onKeyUp={inputKeyUpHandler}
                  className="input-field help_support"
                  value={inputData?.message || ""}
                  placeholder="Write message here..."
                  name="message"
                  onChange={(e) =>
                    setInputData({
                      ...inputData,
                      message: e.target.value,
                      type: "TEXT",
                    })
                  }
                  onKeyDown={onEnterPress}
                />
                {/* <IoImage
            className="input_inside_img"
            onClick={() => setImageModal(true)}
          /> */}
                <button
                  className="send-button"
                  disabled={!inputData?.message}
                  onClick={sendDataHandler}
                >
                  <BsFillSendFill />
                </button>
              </div>
            </>
          </div>
        </div>
      </div>
    </>
  );
};

export default Help_Support;
